module.exports = __webpack_public_path__ + "media/images/area/feature/chubu/related/vi/3-a545702b6408ff3d5e5c4c0d2bb8a028.jpg";